const getCurrentChapter = (flatToc, chapterId) =>
  flatToc.find((tocElement) => tocElement.id === chapterId);

export default getCurrentChapter;
